import script from "./Patients.vue?vue&type=script&setup=true&lang=js"
export * from "./Patients.vue?vue&type=script&setup=true&lang=js"

import "./Patients.vue?vue&type=style&index=0&id=5f254107&scoped=true&lang=scss"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f254107"]])

export default __exports__